import React, { useState, useEffect, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Detail as DetailComponent, InfoHeader } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'cars/car';
const model = 'cars/car';
const wizardName = 'Fringe Benefit Car association';
const wizardObject = 'Fringe Benefit Car';
const wizardAction = 'fringeBenefitAssociation';

const FringeBenefitAssociation = (params) => {
    const { t } = useTranslation();
    const { userCapabilities } = useContext(AppContext);

    const { doAction, item, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart);
    const [selectionStrategy, setSelectionStrategy] = useState('similarity');

    const seeSimilar = () => {
        setSelectionStrategy('similarity');
    }

    const seeAll = () => {
        setSelectionStrategy('all');
    }

    const getFieldset = () => {
        let fieldset = {
            "name": "association",
            "fields": {
                "associated": {
                    "type": "fringebenefitcarlist",
                    "defaultSelectedValues": [],
                    "enableSelection": true,
                    "disableMultipleRowSelection": true,
                    "dataProviderName": "vehicles/fringebenefitcar",
                    "className": "col-12 fringebenefit-list-" + selectionStrategy,
                    "required": "true",
                    "hideTableToolbar": true,
                    "filters": {},
                    "relation":{"selectionStrategy":selectionStrategy},
                    label: (
                        <>
                            <span>{t('All vehicles')}</span>
                            {/* <Button onClick={seeSimilar}>{t('See similar')}</Button> */}
                        </>
                    )
                },
            }
        };

        if (selectionStrategy == 'similarity') {

            fieldset.fields.associated.filters = {
                items: [
                    {
                        'field': 'method',
                        'operator': 'equals',
                        'value': 'similarity'
                    },
                    {
                        'field': 'make',
                        'operator': 'equals',
                        'value': item?.data?.setup?.make
                    },
                    {
                        'field': 'model',
                        'operator': 'equals',
                        'value': item?.data?.setup?.model
                    },
                    {
                        'field': 'setup',
                        'operator': 'equals',
                        'value': item?.data?.setup?.setup
                    },
                    {
                        'field': 'engineDisplacement',
                        'operator': 'equals',
                        'value': item?.data?.setup?.engineDisplacement
                    },
                    {
                        'field': 'powerHp',
                        'operator': 'equals',
                        'value': item?.data?.setup?.powerHp
                    },
                    {
                        'field': 'fuelType',
                        'operator': 'equals',
                        'value': item?.data?.setup?.fuelType
                    }
                ]
            };

            fieldset.fields.associated.label = (
                <>
                    <span>
                        {t('Vehicles similar to {{make}} {{model}} {{setup}}', {
                            make: item?.data?.setup?.make,
                            model: item?.data?.setup?.model,
                            setup: item?.data?.setup?.setup
                        })}
                    </span>
                    {/* <Button onClick={seeAll}>{t('See all')}</Button> */}
                </>
            );
        }

        return [fieldset];
    }

    const detailConfig = useMemo(() => {
        console.info('Selection strategy è cambiata', selectionStrategy)
        return {
            "tabs": [
                {
                    "name": "association",
                    "fieldsets": getFieldset()
                }
            ],
            "validation": []
        }
    }, [selectionStrategy, item]);

    const [editing, setEditing] = useState(false)

    useEffect(() => {
        if (success && editing) {
            (async () => {
                try {
                    await params.handleClose(params.uid, item.data)
                } catch (e) { }
            })()
        }
    }, [success])
    
    const handleSave = (data) => {
        doAction({ action: wizardAction, model: dataProviderName, data: data });
    }

    return <>
        <DetailComponent
            values={{ 
                "id": item?.data?._id 
            }}
            disableDetailConfigOverride={true}
            modelName={model.split('/')[1]}
            detailConfig={detailConfig}
            dataProviderName={dataProviderName}
            onEditing={setEditing}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t(wizardName)}
            canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
            header={
                <InfoHeader
                    view="wizard"
                    title={t(wizardName)}
                    subtitle={t('Select a {{wizardObject}} to be associated to {{carIdentifier}}', { wizardObject: wizardObject, carIdentifier: (item.data.plate + " | " + item.data.setup?.make + " | " + item.data.setup?.model + " | " + item.data.setup?.setup) })}
                />
            }
            {...params}
        />
    </>
}

export default FringeBenefitAssociation;


